/*
 * menu-trigger btn
 * ----------------------------------------------- */
jQuery(function ($) {
  var $menuTrigger = $(".menu-trigger");
  $menuTrigger.on("click", function (event) {
    $("body").toggleClass("overflow-hidden");
  });
});
